import dayjs from "dayjs";
import { DATESYSTEM_TO_FORMAT } from "./pages/subpages/Settings";
import { useAppStore } from "./shared/stores/useAppStore";


const snakeToPascal = str => {
    if (str == null) return '';
    return str.replaceAll('_', ' ').replaceAll(/\w\S*/g, m => m.charAt(0).toUpperCase() + m.substr(1).toLowerCase());
};

const snakeToFirstUpper = str => {
    if (str == null) return '';
    str = str.replaceAll('_', ' ');
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const isFloat = (value) => {
    if (!isNaN(value.toString().replace(',', '.')) && (!isNaN(parseFloat(value.toString().replace(',', '.'))))) {
        return true;
    } else {
        return false
    }
}

const dateWithFormat = (dateStr) => {
    return dayjs(dateStr).format(DATESYSTEM_TO_FORMAT[useAppStore.getState().userSettings.dateSystem])
}

const round = (value, precision) => {
    let valueToUse = value;

    if (value.toString().indexOf(',') != -1) {
        valueToUse = parseFloat(value.toString().replace(',', '.'))
    }

    if (typeof value == 'string') {
        valueToUse = parseFloat(value.replace(',', '.'))
    }

    const exp = Math.pow(10, precision);
    const result = Math.round((valueToUse + Number.EPSILON) * exp) / exp 
    return result == -0 ? 0 : result 
}

function revertLocaleString(formattedString, locale = 'en-US') {
    const numberFormat = new Intl.NumberFormat(locale);
    const parts = numberFormat.formatToParts(1234567.89);
    
    const thousandsSeparator = parts.find(part => part.type === 'group')?.value || ',';
    const decimalSeparator = parts.find(part => part.type === 'decimal')?.value || '.';
    
    // Remove thousands separators and replace decimal separator with a period
    const cleanedString = formattedString
      .replace(new RegExp(`\\${thousandsSeparator}`, 'g'), '')
      .replace(decimalSeparator, '.');
    
    // Parse the string back to a number
    return parseFloat(cleanedString);
  }

export default snakeToPascal;
export { isFloat, round, dateWithFormat, snakeToFirstUpper, revertLocaleString }